import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const fetchPeriods = () => axios.get(`${API}/periods`).then((r) => r.data.periods);
export const fetchPipeline = (periodId) =>
  axios.get(`${API}/pipeline`, { params: { period_id: periodId } }).then((r) => r.data);
export const fetchDataset = (key) => axios.get(`${API}/datasets/${key}`).then((r) => r.data);
export const fetchReconciliation = (periodId) =>
  axios.get(`${API}/reconciliation`, { params: { period_id: periodId } }).then((r) => r.data);
export const fetchException = (invoiceId, periodId) =>
  axios
    .get(`${API}/exceptions/${invoiceId}`, { params: { period_id: periodId } })
    .then((r) => r.data);
export const postExceptionAction = (invoiceId, body) =>
  axios.post(`${API}/exceptions/${invoiceId}/action`, body).then((r) => r.data);
export const fetchCloseReadiness = (periodId) =>
  axios.get(`${API}/close-readiness`, { params: { period_id: periodId } }).then((r) => r.data);
export const approveClose = (periodId) =>
  axios.post(`${API}/close-readiness/approve`, { period_id: periodId }).then((r) => r.data);
export const fetchAuditTrail = (periodId) =>
  axios.get(`${API}/audit-trail`, { params: { period_id: periodId } }).then((r) => r.data);

// Intugleflow run integration
export const startRun = (body) =>
  axios.post(`${API}/reconciliation/runs`, body).then((r) => r.data);
export const fetchRun = (runId) =>
  axios.get(`${API}/reconciliation/runs/${runId}`).then((r) => r.data);
export const fetchLatestRun = (periodId) =>
  axios.get(`${API}/reconciliation/runs/latest`, { params: { period_id: periodId } }).then((r) => r.data);

export const fetchCaseDecision = (caseId) =>
  axios.get(`${API}/reconciliation/cases/${caseId}/decision`).then((r) => r.data);

export const submitCaseDecision = (caseId, body) =>
  axios.post(`${API}/reconciliation/cases/${caseId}/decision`, body).then((r) => r.data);

export const fetchRunDecisions = (runId) =>
  axios.get(`${API}/reconciliation/runs/${runId}/decisions`).then((r) => r.data);

export const fetchCorrectiveActions = (params) =>
  axios.get(`${API}/corrective-actions`, { params }).then((r) => r.data);

export const fetchCorrectiveAction = (taskId) =>
  axios.get(`${API}/corrective-actions/${taskId}`).then((r) => r.data);

export const updateCorrectiveAction = (taskId, body) =>
  axios.patch(`${API}/corrective-actions/${taskId}`, body).then((r) => r.data);

export const fetchEscalations = (params) =>
  axios.get(`${API}/escalations`, { params }).then((r) => r.data);

export const fetchEscalation = (escalationId) =>
  axios.get(`${API}/escalations/${escalationId}`).then((r) => r.data);

export const updateEscalation = (escalationId, body) =>
  axios.patch(`${API}/escalations/${escalationId}`, body).then((r) => r.data);

export const fetchTeams = () =>
  axios.get(`${API}/teams`).then((r) => r.data.teams);

export const compactINR = (v) => {
  if (v === null || v === undefined) return "—";
  if (Math.abs(v) >= 1_000_000) return `${(v / 1_000_000).toFixed(v % 1_000_000 === 0 ? 0 : 2)}M`;
  if (Math.abs(v) >= 1_000) return `${Math.round(v / 1_000)}K`;
  return v.toLocaleString("en-IN");
};

export const formatCell = (v) => {
  if (v === null || v === undefined || v === "") return "—";
  if (typeof v === "number") return v.toLocaleString("en-IN");
  return String(v);
};
